import React from "react";
import { Link } from "react-router-dom";
import { FaTooth, FaUsers, FaRegSmile, FaAward } from "react-icons/fa";

import WelcomeIntro from "../components/WelcomeIntro";
import WelcomeSlideShow from "../components/WelcomeSlideShow";
import "./Welcome.css";

const features = [
  {
    icon: <FaUsers />,
    title: "Family-Owned & Local",
    text: "A locally owned, family-run practice serving Monument and the surrounding Front Range communities.",
  },
  {
    icon: <FaTooth />,
    title: "State-of-the-Art Care",
    text: "Modern equipment and continuing education keep our treatments fast, gentle, and effective.",
  },
  {
    icon: <FaRegSmile />,
    title: "Comfort First",
    text: "From routine cleanings to cosmetic work, your comfort and confidence come first — always.",
  },
  {
    icon: <FaAward />,
    title: "20+ Years of Trust",
    text: "Two decades of restorative and cosmetic dentistry, earning the trust of patients across the Monument area.",
  },
];

const Welcome = () => {
  return (
    <React.Fragment>
      <section className="hero">
        <WelcomeSlideShow />
        <div className="hero__overlay" />
        <div className="hero__content">
          <span className="hero__eyebrow">Monument, Colorado</span>
          <h1 className="hero__title">
            A Healthy, Beautiful Smile You Can Trust
          </h1>
          <p className="hero__subtitle">
            Restorative and cosmetic dentistry from Dr. Marcus Bellamy and team —
            trusted by the Monument community for over 20 years.
          </p>
          <div className="hero__actions">
            <Link to="/NewPatient" className="button button--big">
              Become a Patient
            </Link>
            <Link to="/Contact" className="button button--big button--ghost">
              Contact Us
            </Link>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="feature-grid">
          {features.map((f) => (
            <div className="info-card" key={f.title}>
              <span className="info-card__icon">{f.icon}</span>
              <h3>{f.title}</h3>
              <p>{f.text}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="section intro-section">
        <WelcomeIntro />
      </section>
    </React.Fragment>
  );
};

export default Welcome;
